<template>
    <div class="hello">
        <sui-button floated="right" content="Refresh" icon="refresh" v-on:click="refresh()" />
        <sui-button floated="right" content="Add user" :icon="editor ? 'minus' : 'plus'" v-on:click="editor = !editor" primary />
        <h1>Users</h1>
        
        <div v-if="editor">
        <h3 is="sui-header" attached="top">Add user</h3>
            <sui-segment attached>
                <sui-input type="email" placeholder="user@domain.tld" v-model="newUserEmail" />
                <sui-dropdown
                    placeholder="Role"
                    selection
                    :options="roles"
                    v-model="newUserRole"
                />
                <sui-button content="Add" icon="plus" v-on:click="addUser" primary />
            </sui-segment>
        </div>
    
        <sui-table single-line>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell>Name</sui-table-header-cell>
                    <sui-table-header-cell>Role</sui-table-header-cell>
                    <sui-table-header-cell>Remove</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>
            <sui-table-body>
                <sui-table-row v-for="user in users" v-bind:key="user.userId">
                    <sui-table-cell>{{ user.name }}</sui-table-cell>
                    <sui-table-cell>{{ user.role }}</sui-table-cell>
                    <sui-table-cell>
                        <sui-button content="Remove" icon="trash" negative  size="mini" v-on:click="deleteUser(user.userId)" />
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>
        </sui-table>

        <h1>Invites</h1>
        
        <sui-table single-line>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell>Email</sui-table-header-cell>
                    <sui-table-header-cell>Role</sui-table-header-cell>
                    <sui-table-header-cell>Created at</sui-table-header-cell>
                    <sui-table-header-cell>Remove</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>
            <sui-table-body>
                <sui-table-row v-for="invite in invites" v-bind:key="invite.email">
                    <sui-table-cell>{{ invite.email }}</sui-table-cell>
                    <sui-table-cell>{{ invite.role }}</sui-table-cell>
                    <sui-table-cell>{{ invite.createdAt | moment }}</sui-table-cell>
                    <sui-table-cell>
                        <sui-button content="Remove" icon="trash" negative  size="mini" v-on:click="deleteInvitation(invite.email)" />
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>
        </sui-table>
    </div>
  
  
  
</template>

<script>
import DziService from '@/DziService'
import { mapState } from 'vuex'
import { Auth } from 'aws-amplify'

export default {
    name: 'UserList',
    data () {
        return {
            editor: false,
            newUserEmail: null,
            newUserRole: 'user',
            roles: [
                {value: 'admin', text: 'Admin'},
                {value: 'user', text: 'User'}
            ]
        }
    },  
    computed: mapState([
        'users',
        'invites',
        'userId'
    ]),
    methods: {
        refresh() {
            this.getUsers();
            this.getInvites();
        },
        async getUsers () {
            const response = await DziService.getUsers()
            this.$store.commit('setUsers', response.data);
        },
        async getInvites () {
            const response = await DziService.getInvites()
            this.$store.commit('setInvites', response.data);
        },
        async addUser() {
            DziService.addUser(this.newUserEmail, this.newUserRole)
                .then(() => {
                    this.editor = false;
                    this.newUserEmail = null;
                    this.refresh();
                })
                .catch(err => {
                    this.$store.commit('setError', 'Can\'t add user: ' + err);
                });
        },
        async deleteInvitation (email) {
            DziService.deleteInvitation(email)
            .then(() => {
                this.refresh();
            })
            .catch(err => {
                this.$store.commit('setError', 'Can\'t remove invitation: ' + err);
            });
            
        },
        async deleteUser (userId) {
            // zkontrolujeme, zda to neni prihlaseny uzivatel
            let isMe = await Auth.currentAuthenticatedUser().then(user => {
                return user.username && userId==user.username;
            });

            
            if (!isMe)
            {
                
                DziService.deleteUser(userId)
                .then(() => {
                    this.refresh();
                })
                .catch(err => {
                    this.$store.commit('setError', 'Can\'t remove user: ' + err);
                });
                
            }
            else
            {
                this.$store.commit('setError', 'You can\'t remove yourself');
            }
            
        },
    },
    mounted () {
        if (!this.$store.getters.getUsers || this.$store.getters.getUsers.length<1)
            this.refresh();
        
        }
        
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
